import { Badge } from "@/_old/components/ui/badge";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenu as SidebarMenuUI,
  useSidebar,
} from "@/_old/components/ui/sidebar";
import { EVENTS, useActionsTrack } from "@/_old/features/analytics";
import { useLocation, useNavigate } from "react-router-dom";
import { useMenu } from "../hooks/useMenu";

export function SidebarMenu() {
  const { state, toggleSidebar, isMobile } = useSidebar();

  const { items } = useMenu();

  const { onActionClick } = useActionsTrack();

  const navigate = useNavigate();
  const location = useLocation();

  const hideText = state === "collapsed";

  const onNavigate = (link: string, isExternal?: boolean, tracker?: string) => {
    if (tracker) {
      onActionClick(tracker as keyof typeof EVENTS, "MENU");
    }
    if (isExternal) {
      window.open(link, "_blank");
    } else {
      navigate(link);
    }

    if (isMobile) {
      toggleSidebar();
    }
  };

  return (
    <>
      {items.map((section) => (
        <SidebarGroup key={section.title}>
          <SidebarGroupLabel className="p-0 text-xs font-medium text-sidebar-foreground/70">
            {section.title}
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenuUI>
              {section.items.map((item) => {
                const link = item.link?.split("/")[1];
                const isActive =
                  link && location.pathname.startsWith(`/${link}`);
                return (
                  <SidebarMenuItem key={item.id}>
                    <SidebarMenuButton asChild isActive={!!isActive}>
                      <a
                        onClick={() =>
                          onNavigate(
                            item.link ?? "",
                            item.external,
                            item.tracker,
                          )
                        }
                        className={`flex items-center gap-2 cursor-pointer ${hideText ? "justify-center" : ""}`}
                      >
                        {item.icon()}
                        {!hideText && (
                          <span className="text-primary">{item.title}</span>
                        )}
                        {item.badge && !hideText && (
                          <Badge className="ml-0 bg-primary-500 text-primary hover:bg-primary-500/80">
                            {item.badge}
                          </Badge>
                        )}
                      </a>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenuUI>
          </SidebarGroupContent>
        </SidebarGroup>
      ))}
    </>
  );
}
